export const RENT_TIME_LIMITS = {
  minHours: 9,
  maxHours: 21,
  minMinutes: 0,
  maxMinutes: 45,
};

export const CLOSE_TIME_LIMITS = {
  minHours: 9,
  maxHours: 22,
  minMinutes: 0,
  maxMinutes: 0,
};
